import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import {
  Box,
  Typography,
  Modal,
  IconButton,
  Button,
  TextField,
  InputAdornment,
  Popper,
} from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  HOME_PAGE,
  PRODUCT_DETAILS,
  SHOPPING_CART_MODAL,
} from "../../../constants/lang";
import StyledShoppingCartModal from "./addToBagStyles";
import { useSearchbox } from "../../Homepage/Banner/Searchbox/useSearchbox";
import { useAddToCart } from "../../../hooks/common-hooks/useAddToCart";
import { Autocomplete } from "@mui/material";
import TripDetailsCard from "../CreateTrip/TripDetailsCard";
import AddTripCard from "../CreateTrip/AddTripCard";
import { useShoppingCart } from "../../../context/ShoppingCartContext";
import ReplaceTrip from "./ReplaceTrip";
import { useSelector } from "react-redux";
import { selectorfavouriteProducts } from "../../../store/reducers/favourites";
import { useFavourite } from "../../../hooks/common-hooks/useFavourite";
import {
  getMatchingItemSizes,
  isMatchingItem,
} from "../../../utils/commonFuntions";
import { ROUTE_PATH } from "../../../constants/route";
import FavSvg from "../../../assets/icons/newFavIcon.svg";
import FavSelectedSvg from "../../../assets/icons/fav-selected.svg";

const CustomPopper = (props) => {
  return (
    <Popper
      {...props}
      modifiers={[
        {
          name: "width",
          enabled: true,
          phase: "beforeWrite",
          requires: ["computeStyles"],
          fn: ({ state }) => {
            state.styles.popper.width = `${state.rects.reference.width + 89}px`;
            state.styles.popper.marginLeft = "4px";
          },
        },
      ]}
    />
  );
};

const ShoppingCartModal = () => {
  const [showCreateTrip, setShowCreateTrip] = useState(false);
  const {
    selectedProduct,
    isOpen,
    onClose,
    isFormOpen,
    isDiscardModalOpen,
    setDiscardModalOpen,
    bagItems,
    setSelectedProductExistInCart,
    isSelectedProductExistInCart,
    setIsFormOpen,
    tripDetails,
  } = useShoppingCart();
  const handleSizeSelect = (size) => {
    setSelectedSize(size);
  };

  const {
    open,
    setOpen,
    cityValue,
    setCityValue,
    optionsCitys,
    value,
    setValue,
    optionsHotels,
    selectedDate,
    setSelectedDate,
    minSelectableDate,
    onSubmit,
    reset,
  } = useSearchbox(setShowCreateTrip);
  const {
    selectedColor,
    setSelectedColor,
    selectedSize,
    setSelectedSize,
    onAddToCart,
    error,
    outOfStock,
    setOutOfStock,
    selectedTrip,
    setSelectedTrip,
    loadingTripDetails,
    discardBag,
    discardTripLoader,
    setError,
    addtoCartLaoding,
  } = useAddToCart(showCreateTrip, isDiscardModalOpen, selectedProduct, reset);

  const sizeMapping = useMemo(() => {
    const sizes = selectedProduct?.variants?.map((variant) => variant?.size_obj?.code);
    return [...new Set(sizes)]; // Remove duplicates and return unique sizes
  }, [selectedProduct?.variants]);

  useEffect(() => {
    if (isFormOpen) {
      setShowCreateTrip(true);
      if (tripDetails?.city_name)
        setCityValue({
          id: tripDetails?.city,
          name: tripDetails?.city_name,
        });
      else setCityValue(null);
      if (tripDetails?.hotel_name)
        setValue({
          id: tripDetails?.hotel,
          name: tripDetails?.hotel_name,
        });
      else setValue(null);
      if (tripDetails?.arrival_date) {
        const date = new Date(tripDetails?.arrival_date);
        const timestamp = date.getTime();
        setSelectedDate(timestamp);
      } else setSelectedDate(null);
    } else {
      setShowCreateTrip(false);
    }
    // eslint-disable-next-line
  }, [isFormOpen, tripDetails, isOpen]);

  const { favProducts } = useSelector(selectorfavouriteProducts);
  const { setFavouriteProduct, removeFavProduct, loading } = useFavourite();
  const availableSizes = useMemo(() => {
    return selectedProduct?.variants
      ?.filter((variant) => variant?.color_obj?.label === selectedColor)
      ?.map((variant) => variant?.size_obj?.code);
    // eslint-disable-next-line
  }, [selectedProduct?.variants, selectedColor, selectedSize]);
  useEffect(() => {
    if (!availableSizes?.includes(selectedSize)) {
      setOutOfStock(true);
    } else {
      setOutOfStock(false);
    }
    // eslint-disable-next-line
  }, [availableSizes, selectedSize]);
  useEffect(() => {
    if (selectedProduct?.variants?.[0]?.color)
      setSelectedColor(selectedProduct?.variants?.[0]?.color);
    setSelectedSize(null);
    setError("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);

  useEffect(() => {
    if (
      bagItems?.length > 0 &&
      (selectedSize === undefined || selectedSize === null)
    ) {
      const size = getMatchingItemSizes(
        bagItems,
        selectedColor,
        selectedProduct?.id
      );
      setSelectedSize(size[0] || null);
    }
    // eslint-disable-next-line
  }, [bagItems, selectedSize, selectedColor, selectedProduct?.id]);

  function getButtonText() {
    if (isOpen) {
      if (
        isMatchingItem(
          bagItems,
          selectedSize,
          selectedColor,
          selectedProduct?.id
        )
      ) {
        setSelectedProductExistInCart(true);
        return "Go to bag";
      } else {
        setSelectedProductExistInCart(false);
        if (bagItems)
          if (outOfStock && selectedSize) return PRODUCT_DETAILS.out_of_stock;
          else return PRODUCT_DETAILS.add_bag;
      }
    }
  }
  const onSubmitClick = () => {
    if (getButtonText() !== "Go to bag") onAddToCart();
    else {
      onClose();
      window.location.href = ROUTE_PATH.BAG;
    }
  };

  const handleHowItWorksClick = () => {
    window.open('/how-it-works', '_blank');
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby='shopping-cart-modal'
    >
      <StyledShoppingCartModal>
        <Box className='modal-container'>
          {isDiscardModalOpen ? (
            <Box className='modal-content' onClick={(e) => e.stopPropagation()}>
              <ReplaceTrip
                tripDetails={tripDetails}
                onToggle={() =>
                  selectedProduct ? setDiscardModalOpen(false) : onClose()
                }
              />
            </Box>
          ) : (
            <Box className='modal-content' onClick={(e) => e.stopPropagation()}>
              {/* Header */}
              <Box className='modal-header'>
                {showCreateTrip ? (
                  <IconButton
                    onClick={() =>
                      isFormOpen ? onClose() : setShowCreateTrip(false)
                    }
                  >
                    <ArrowBackIcon />
                  </IconButton>
                ) : (
                  <IconButton onClick={onClose}>
                    <CloseIcon />
                  </IconButton>
                )}
                <Typography variant='h6' className='heading-1' sx={{ ml: 1 }}>
                  {showCreateTrip
                    ? SHOPPING_CART_MODAL.headings.createTrip
                    : SHOPPING_CART_MODAL.headings.addToBag}
                </Typography>
              </Box>

              {showCreateTrip ? (
                <Box>
                  <Typography className='create-trip-description'>
                    {SHOPPING_CART_MODAL.messages.addTripDetails}
                  </Typography>
                  <Box sx={{ p: "6px", display: "inline-flex", alignItems: "center", justifyContent: "start", gap: "4px", bgcolor: "#F0F0F0"}}>
                    <InfoOutlinedIcon sx={{ fontSize: '16px', color: "#0F0F0F !important" }} className='infoIcon' />
                    <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "#656565" }}>
                      Want help creating a trip? learn
                    </Typography>
                    <Button 
                      variant='text' 
                      onClick={handleHowItWorksClick}
                      sx={{ 
                        mr: "0px !important",
                        fontSize: "12px", 
                        fontWeight: 600, 
                        color: "#7D634F",
                        textDecoration: "underline",
                        textTransform: "none",
                        padding: "0",
                        width: "fit-content !important",
                        height: "fit-content !important",
                        "&:hover": {
                          textDecoration: "underline",
                          bgcolor: 'unset !important'
                        }
                      }}
                    >
                      how it works!
                    </Button>
                  </Box>

                  <div className='cart-container'>
                    <div className='container1'>
                      <div className='autocomplete-box'>
                        <Box className='buttons'>
                          <PlaceOutlinedIcon
                            sx={{ marginLeft: "1px" }}
                            className='text-white'
                          />
                          <Autocomplete
                            aria-label='Select City'
                            placeholder={HOME_PAGE.searchBar.selectCity}
                            value={cityValue}
                            onChange={(event, newValue) =>
                              setCityValue(newValue)
                            }
                            options={optionsCitys}
                            getOptionLabel={(option) => option.name}
                            // sx={{width: "81%"}}
                            className='autocomplete-input-style'
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant='standard'
                                placeholder='Select City'
                                sx={{
                                  "& .MuiInput-underline:before": {
                                    borderBottom: "none",
                                  },
                                }}
                                className='autocomplete-input'
                              />
                            )}
                            popupIcon={
                              <KeyboardArrowDownIcon className='text-white' />
                            }
                            PopperComponent={CustomPopper}
                          />
                        </Box>
                      </div>
                      <div className='autocomplete-box'>
                        <div className='buttons'>
                          <MapsHomeWorkOutlinedIcon className='text-white' />
                          <Autocomplete
                            aria-label='Select Hotel'
                            placeholder={HOME_PAGE.searchBar.selectHotel}
                            value={value}
                            onChange={(event, newValue) => setValue(newValue)}
                            options={optionsHotels}
                            getOptionLabel={(option) => option.name}
                            className='autocomplete-input-style'
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant='standard'
                                placeholder='Select Hotel'
                              />
                            )}
                            popupIcon={
                              <KeyboardArrowDownIcon className='text-white' />
                            }
                            PopperComponent={CustomPopper}
                          />
                        </div>
                      </div>

                      <LocalizationProvider
                        dateAdapter={AdapterMoment}
                        adapterLocale='en'
                        desktopModeMediaQuery='@media (pointer: fine)'
                      >
                        <div className='dropdown-box1-1'>
                          <div className='datepicker-1'>
                            <DatePicker
                              className='datepicker'
                              value={selectedDate ? moment(selectedDate) : null}
                              onChange={(newDate) => {
                                if (newDate && moment(newDate).isValid()) {
                                  setSelectedDate(moment(newDate).valueOf());
                                } else {
                                  setSelectedDate(null);
                                }
                              }}
                              format='DD/MM/YYYY'
                              open={open}
                              minDate={minSelectableDate}
                              onOpen={() => setOpen(true)}
                              onClose={() => setOpen(false)}
                              renderInput={({ inputProps, ...restParams }) => (
                                <TextField
                                  {...restParams}
                                  className='custom-textfield'
                                  autoComplete='off'
                                  onClick={() => setOpen(!open)}
                                  defaultValue={null}
                                  InputProps={{
                                    ...inputProps.InputProps,
                                    placeholder:
                                      HOME_PAGE.searchBar.arrivalDate1,
                                    value: selectedDate
                                      ? moment(selectedDate).format("DD/MM/YY")
                                      : "",
                                    startAdornment: (
                                      <InputAdornment
                                        aria-label='Open calendar'
                                        position='start'
                                        sx={{ marginLeft: "4px" }}
                                      >
                                        <CalendarMonthOutlinedIcon
                                          className='text-white'
                                          aria-label='Open Calendar'
                                          onClick={() => setOpen(!open)}
                                        />
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <Box display='flex' paddingRight='6px'>
                                        {selectedDate && (
                                          <InputAdornment
                                            sx={{ position: "relative" }}
                                            aria-label='Clear Date'
                                            position='end'
                                          >
                                            <CloseIcon
                                              aria-label='Open Calendar'
                                              className='close-icon'
                                              onClick={(e) => {
                                                setSelectedDate(null);
                                                e.stopPropagation();
                                              }}
                                            />
                                          </InputAdornment>
                                        )}
                                        <InputAdornment
                                          aria-label='Open calendar'
                                          position='end'
                                        >
                                          <KeyboardArrowDownIcon
                                            className='text-white'
                                            onClick={() => setOpen(!open)}
                                          />
                                        </InputAdornment>
                                      </Box>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </LocalizationProvider>
                    </div>
                  </div>
                </Box>
              ) : (
                // Add to Bag Content
                <Box className='products-container'>
                  {/* Product Details */}
                  <Box className='product-details'>
                    <Box
                      component='img'
                      loading='lazy'
                      src={selectedProduct?.variants?.[0]?.variant_img?.[0]}
                      alt='Product'
                      className='product-image'
                    />
                    <Box>
                      <Typography className='heading-2'>
                        {selectedProduct?.designer?.name}
                      </Typography>
                      <Typography className='heading-3'>
                        {selectedProduct?.name}
                      </Typography>
                      <Typography className='heading-4'>
                        ${selectedProduct?.price}
                      </Typography>
                    </Box>
                  </Box>

                  <Box className='line' />

                  {/* Select Size */}
                  <Box className='size-selector'>
                    <Typography className='heading-5' sx={{ mb: 1 }}>
                      {SHOPPING_CART_MODAL.headings.selectYourSize}
                    </Typography>
                    <Typography className='title-1' sx={{ mb: 1 }}>
                      {SHOPPING_CART_MODAL.headings.selectedSize}{" "}
                      {selectedSize || " "}
                    </Typography>
                    <Box className='size-options'>
                      {sizeMapping?.map((size) => (
                        <Box
                          key={size}
                          className={`size-box ${selectedSize === size ? "selected" : ""}`}
                          sx={{
                            backgroundColor: availableSizes?.includes(size)
                              ? selectedSize === size
                                ? "#A78D78"
                                : "transparent"
                              : "#F0F0F0",
                            color: availableSizes?.includes(size)
                              ? selectedSize === size
                                ? "white"
                                : "black"
                              : "#959595",
                            border:
                              selectedSize === size
                                ? "1.5px solid black"
                                : "1.5px solid transparent",
                          }}
                          onClick={() => handleSizeSelect(size)}
                        >
                          {size}
                          {!availableSizes?.includes(size) && (
                            <Box className='line1' />
                          )}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                  <Box className='line' />

                  {/* Select Trip */}
                  <Typography className='heading-6'>
                    {SHOPPING_CART_MODAL.headings.selectYourTrip}
                  </Typography>

                  <TripDetailsCard />


                  <Box className='cards-container'>
                    <TripDetailsCard
                      tripDetails={tripDetails}
                      loadingTripDetails={loadingTripDetails}
                      selectedTrip={selectedTrip}
                      setSelectedTrip={setSelectedTrip}
                      setIsFormOpen={() => setIsFormOpen(true)}
                    />

                    <AddTripCard
                      onClick={() =>
                        tripDetails?.id
                          ? setDiscardModalOpen(true)
                          : setShowCreateTrip(true)
                      }
                    />
                    {error && (
                      <Typography className='error'>{error}</Typography>
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {isDiscardModalOpen ? (
            <Box className='footer-actions'>
              <Box className='replace-buttons'>
                <Button
                  onClick={() =>
                    selectedProduct ? setDiscardModalOpen(false) : onClose()
                  }
                  variant='outlined'
                  className='cancel-button'
                >
                  {SHOPPING_CART_MODAL.buttons.cancel}
                </Button>
                <Button
                  disabled={discardTripLoader}
                  loading={discardTripLoader}
                  onClick={() => discardBag(tripDetails?.id)}
                  variant='contained'
                  className='replace-button'
                >
                  {SHOPPING_CART_MODAL.buttons.replace}
                </Button>
              </Box>
            </Box>
          ) : (
            <Box className='footer-actions'>
              <Box className='width-footer'>
                {!showCreateTrip && (
                  <>
                    {favProducts?.includes(selectedProduct?.id) ? (
                      <IconButton
                        disabled={loading}
                        onClick={(e) => {
                          removeFavProduct(selectedProduct?.id);
                          e.stopPropagation();
                        }}
                        className='favIcon hover-download'
                      >
                        <img src={FavSelectedSvg} alt="Fav icon"
                          aria-label='Remove from favourite'
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        disabled={loading}
                        onClick={(e) => {
                          setFavouriteProduct(selectedProduct?.id);
                          e.stopPropagation();
                        }}
                        className='favIcon hover-download'
                      >
                        <img src={FavSvg} alt="Fav icon"
                          aria-label='Add to favorites'
                        />

                      </IconButton>
                    )}
                  </>
                )}
                {!showCreateTrip ? (
                  <Button
                    disabled={(outOfStock && selectedSize) || addtoCartLaoding}
                    loading={addtoCartLaoding}
                    variant='contained'
                    className={`heading-9 ${isSelectedProductExistInCart && "go-to-bag"}`}
                    color='primary'
                    fullWidth
                    onClick={() => onSubmitClick()}
                  >
                    <ShoppingBagOutlinedIcon
                      sx={{ color: "white !important" }}
                    />
                    {getButtonText()}
                  </Button>
                ) : (
                  
                  <Button
                    variant='contained'
                    className='heading-99'
                    color='primary'
                    fullWidth
                    sx={{ margin: "0px auto" }}
                    onClick={() => onSubmit(tripDetails?.id || null)}
                    style={{ margin: "0px auto" }}
                  >
                    {tripDetails?.id
                      ? SHOPPING_CART_MODAL.buttons.updateTrip
                      : SHOPPING_CART_MODAL.buttons.createTrip}
                  </Button>
                )}
              </Box>
            </Box>
          )}
        </Box>
      </StyledShoppingCartModal>
    </Modal>
  );
};

export default ShoppingCartModal;
